import React, { memo, FC } from 'react';
import { useUnitStyles } from './styles';

export interface UnitProps {
  isArrowShow: boolean;
  unittxt: string;
};

const Unit: FC<UnitProps> = ({ isArrowShow, unittxt }) => {
  const styles = useUnitStyles([isArrowShow]);

  return (
    <div className={styles.unit}>{ unittxt }</div>
  );
};

export default memo(Unit);
